import { IconChevronLeftRegular, NavigationBar, skinVars, Text2 } from '@telefonica/mistica';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import './index.scss';

type GenericHeaderType = {
    title: string;
    navigationBarOnBack: () => void;
    onReturn?: () => void;
    withBorder?: boolean;
};

const GenericHeader = ({ title, navigationBarOnBack, onReturn, withBorder = false }: GenericHeaderType) => {
    const navigate = useNavigate();

    const returnHandler = () => (onReturn ? onReturn() : navigate(-1));

    return (
        <div className='generic-header'>
            <div className='generic-header__navigationBar'>
                <NavigationBar withBorder={withBorder} onBack={navigationBarOnBack} title={title} />
            </div>
            <div className='generic-header__return'>
                <div className='generic-header__return-icon' onClick={returnHandler}>
                    <IconChevronLeftRegular color={skinVars.colors.textPrimary} size={20} />
                </div>
                <div className='generic-header__return-back' onClick={returnHandler}>
                    <Text2 medium color={skinVars.colors.textPrimary}>
                        {t('returnResponsive')}
                    </Text2>
                </div>
            </div>
        </div>
    );
};

export default GenericHeader;
